import Mentions from './Mentions';
export default Mentions;


//////////////////
// WEBPACK FOOTER
// ./~/rc-mentions/es/index.js
// module id = 1366
// module chunks = 0